import { Popover } from "@material-ui/core";

export type { PopoverProps as IPopoverProps } from "@material-ui/core";

export default Popover;
